import styled from 'styled-components';

const LogoStyle = styled.div`
	--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp27x)')};
	--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp7x)' : '')};

	width: var(--headerLogoSize);
	margin-top: var(--headerMarginTop);

	a {
		width: 100%;
	}

	.imageCont {
		--imagePaddingTop: 17.2%;

		background-color: transparent !important;

		img {
			width: 100% !important;
			height: auto;
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp20x)')};
		--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp5x)' : '')};
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp15x)')};
		--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp4x)' : '')};
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp15x)')};
		--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp4x)' : '')};
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp14x)')};
		--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp4x)' : '')};
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp14x)')};
		--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp4x)' : '')};
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp14x)')};
		--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp4x)' : '')};
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--headerLogoSize: ${(props) => (props.type === 'footer' ? '100%' : 'var(--sp14x)')};
		--headerMarginTop: ${(props) => (props.type === 'footer' ? 'var(--sp5x)' : '')};
	}
`;

export default LogoStyle;
